import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar'
import { CustomSnackBarComponent } from "@app/shared/components/custom-snack-bar/custom-snack-bar.component";


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) {

  }

  notify(type: 'success' | 'error' | 'warning' | 'info' | 'default' = 'default', message: string, duration: number = 6000, horizontalPosition: MatSnackBarHorizontalPosition = 'end', verticalPosition: MatSnackBarVerticalPosition = 'bottom') {
    let className: string;

    switch(type) {
      case 'success':
        className = 'snack-bar-success';
        break;
      case 'error':
        className = 'snack-bar-error';
        break;
      case 'warning':
        className = 'snack-bar-warning';
        break;
      case 'info':
        className = 'snack-bar-info';
        break;
      default:
        className = 'snack-bar-default';
    }

    this.snackBar.openFromComponent(CustomSnackBarComponent, {
      data: {message},
      duration: duration,
      panelClass: [className],
      verticalPosition: verticalPosition,
      horizontalPosition: horizontalPosition
    })
  }
}
